module.exports = __webpack_public_path__ + "img/recruitc60.07e3c6d6.png";